import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["data", "oneLink", "magaly"];
import React from 'react';
import ShareLinksActions from '../components/ShareLinksActions';
import ShareLinksProduct from '../components/ShareLinksProduct';
import { useCookies } from '@magalu/mixer-utils';
import { EventLinkType, ShortenLinkTypes, TabDescription, TabTitle } from '../constants';
var useShareActionsTabsContent = function useShareActionsTabsContent(_ref) {
  var data = _ref.data,
    oneLink = _ref.oneLink,
    magaly = _ref.magaly,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useCookies = useCookies(),
    _useCookies$toggleSha = _useCookies.toggleSharePromoterOfferLink,
    toggleSharePromoterOfferLink = _useCookies$toggleSha === void 0 ? '' : _useCookies$toggleSha;
  var appMagaluDescription = !!toggleSharePromoterOfferLink && toggleSharePromoterOfferLink !== 'false' ? TabDescription.OFFER_MAGALU : TabDescription.APP_MAGALU;
  var getShortenLink = function getShortenLink(shortenLinkType) {
    return shortenLinkType === ShortenLinkTypes.ONELINK ? oneLink.shortenLink : magaly.shortenLink;
  };
  var getUrlToCopy = function getUrlToCopy(shortenLinkType) {
    return shortenLinkType === ShortenLinkTypes.ONELINK ? oneLink.urlToCopy : magaly.urlToCopy;
  };
  var getLinkType = function getLinkType(shortenLinkType) {
    return shortenLinkType === ShortenLinkTypes.ONELINK ? EventLinkType.APP_MAGALU : EventLinkType.INFLUENCIADOR_MAGALU;
  };
  var getTabContent = function getTabContent(description, shortenLinkType) {
    return React.createElement(React.Fragment, null, React.createElement(ShareLinksProduct, {
      data: data,
      device: props.staticProps.device || 'desktop',
      description: description
    }), React.createElement(ShareLinksActions, _extends({
      data: data,
      linkType: getLinkType(shortenLinkType),
      shortenLink: getShortenLink(shortenLinkType),
      urlToCopy: getUrlToCopy(shortenLinkType)
    }, props)));
  };
  return [{
    content: getTabContent(appMagaluDescription, ShortenLinkTypes.ONELINK),
    label: TabTitle.APP_MAGALU
  }, {
    content: getTabContent(TabDescription.INFLUENCIADOR_MAGALU, ShortenLinkTypes.MAGALY),
    label: TabTitle.INFLUENCIADOR_MAGALU
  }];
};
export default useShareActionsTabsContent;